/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LoanDisburseInputDto { 
    loanId: number;
    amount?: number;
    pin?: string | null;
    description?: string | null;
    paymentTransactionModeId?: number | null;
    paymentProviderId?: string | null;
    paymentProviderWalletId?: string | null;
    paymentProviderName?: string | null;
    destinationCode?: string | null;
    fee?: number;
    mpin?: string | null;
    otp?: string | null;
}

